import { render, staticRenderFns } from "./EModalBnccFranquia.vue?vue&type=template&id=00d1f215&scoped=true"
import script from "./EModalBnccFranquia.vue?vue&type=script&lang=js"
export * from "./EModalBnccFranquia.vue?vue&type=script&lang=js"
import style0 from "./EModalBnccFranquia.vue?vue&type=style&index=0&id=00d1f215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d1f215",
  null
  
)

export default component.exports